import gitimg from '../assets/github.png'
const Projectlist = [{    id:1,
    Name: "Personal Portfolio using react js ",
    srcc: gitimg,
    link:"/"
},
{   id:2,
    Name: "Bechna:A broker website for selling products online",
    srcc:  gitimg,
    link:"/"
}
]
export default Projectlist;